import { createContext, useContext, useEffect, useRef, useState, useMemo } from 'react';
import { apiFetch } from '../../api/api';
import { useAuth } from '../../auth/auth-context';

const OrgContext = createContext(null);

export function OrgProvider({ children }) {
  const [orgs, setOrgs] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [activeOrgId, setActiveOrgId] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  async function fetchAll() {
    try {
      setLoading(true);

      const [orgData, membershipData] = await Promise.all([
        apiFetch('/org'),
        apiFetch('/org/memberships'),
      ]);

      setOrgs(orgData || []);
      setMemberships(membershipData || []);
    } finally {
      setLoading(false);
    }
  }

  const switchOrg = (orgId) => {

    const canSwitch =
      user?.globals?.includes('superadmin') ||
      user?.roles?.includes('org:admin') ||
      user?.roles?.includes('org:owner');

      console.log('canSwitch', canSwitch);

    if (!canSwitch) {
      console.warn('Org switching blocked for non-admin user');
      return false;
    }

    const org = orgs.find(o => String(o._id) === String(orgId));
    if (!org) {
      console.warn('Selected org not found:', orgId);
      return false;
    }

    setActiveOrgId(orgId);
    localStorage.setItem('activeOrgId', orgId);

    setTimeout(() => {
      window.location.reload();
    }, 10);

    return true;
  };

  // const switchOrg = (orgId) => {
  //   const org = orgs.find(o => o._id === orgId);
  //   if (!org) return;
  //
  //   // setActiveOrg(org);
  //   setActiveOrgId(orgId);
  //
  //   localStorage.setItem('activeOrgId', orgId);
  // };

  useEffect(() => {
    if (!orgs.length) return;

    const storedOrgId = localStorage.getItem('activeOrgId');
    if (!storedOrgId) return;

    const org = orgs.find(o => o._id === storedOrgId);
    if (org) {
      setActiveOrgId(org._id);
    }
  }, [orgs]);

  const bootstrappedRef = useRef(false);

  useEffect(() => {
    if (!user) {
      setOrgs([]);
      setMemberships([]);
      setActiveOrgId(null);
      bootstrappedRef.current = false;
      return;
    }

    // 🔒 Only bootstrap ONCE per login
    if (bootstrappedRef.current) return;

    bootstrappedRef.current = true;
    fetchAll();

    const saved = localStorage.getItem('activeOrgId');
    if (!saved && orgs.length === 1) {
      setActiveOrgId(orgs[0]._id);
      localStorage.setItem('activeOrgId', orgs[0]._id);
    }
  }, [user]);



  const activeOrg = useMemo(
    () => orgs.find(o => String(o._id) === String(activeOrgId)) || null,
    [orgs, activeOrgId]
  );

  return (
    <OrgContext.Provider
      value={{
        orgs,
        memberships,
        activeOrg,
        activeOrgId,
        switchOrg,
        fetchOrgs: fetchAll,
        loading,
      }}
    >
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error('useOrg must be used inside OrgProvider');
  return ctx;
}
